module.exports = __webpack_public_path__ + "img/sphere5.924e8d09.png";